import { toast } from 'sonner';
import { isNil } from 'ramda';

// lang
const { __ } = '@wordpress/i18n'; // eslint-disable-line no-undef

/**
 * Handle success msg displaying
 *
 * @param {string} msg
 * @param {object} args
 *
 * @returns (void)
 */
const handleSuccessAndDisplay = (msg, args = {}) => {
    const config = {
        'className': 'uniSonnerNotifications toastSuccess',
        ...args
    }

    toast.success(isNil(msg) ? __('Success!', 'soundbetween') : msg, config);
};

export default handleSuccessAndDisplay;